import { useState, useEffect } from "react";
import { Footer, Navbar } from "../components";
import { useSelector, useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link, useParams, useLocation } from "react-router-dom";
import configData from "../config.json";
import "../styles/product.css";

const CatProducts = () => {
  // const { catID } = useParams();
  const location = useLocation();
  const {categoryId } = location.state || {};

  const cart = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();

  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const Rating = ({ value = 0, count = 0 }) => {
  const numValue = Number(value) || 0;   // ✅ force number
  const rounded = Math.round(numValue);

  return (
    <div className="small mb-1">
      <span className="text-warning">
        {"★".repeat(rounded)}
        {"☆".repeat(5 - rounded)}
      </span>
      <span className="text-muted ms-1">
        {numValue.toFixed(1)} {count ? `(${count})` : ""}
        {/* {'['+count+']'} */}
      </span>
    </div>
  );
};

  // 🔹 Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [subCatRes, typeRes, prodRes, featRes] = await Promise.all([
          fetch(`${configData.SERVER_URL}/subcategory/${categoryId}`),
          fetch(`${configData.SERVER_URL}/itemType/${categoryId}`),
          fetch(`${configData.SERVER_URL}/products/category/${categoryId}`),
          fetch(`${configData.SERVER_URL}/featureProducts`)
        ]);

        const subCatData = await subCatRes.json();
        const typeData = await typeRes.json();
        const prodData = await prodRes.json();
        const featData = await featRes.json();

        setSubCategories(subCatData);
        setItemTypes(typeData);
        setProducts(prodData);
        setFiltered(prodData);
        setFeatured(featData);

      } catch (err) {
        console.error(err);
        setError("Failed to load products");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [categoryId]);

  // 🔹 Add to Cart
  const handleAddCart = (product) => {
    if (cart.length > 0) {
      const sameBranch = cart.every(
        (item) => item.BranchId === product.BranchId
      );

      if (!sameBranch) {
        alert("Multiple branch products are not allowed in one cart");
        return;
      }
    }

    dispatch(addCart(product));
  };

  // 🔹 Filters
  const filterBySubCategory = (name) => {
    setFiltered(products.filter((p) => p.subCategory === name));
    setSelectedType("");
  };

  const filterByItemType = (type) => {
    setSelectedType(type);
    setFiltered(products.filter((p) => p.ItemType === type));
  };

  const resetFilters = () => {
    setFiltered(products);
    setSelectedType("");
  };

  return (
    <>
      <Navbar />

      <div className="container py-4">

        {/* Header */}
        <div className="text-center mb-4">
          <h2 className="fw-bold text-success">Category Products</h2>
          <p className="text-muted">Browse category products</p>
        </div>

        {/* Error */}
        {error && <p className="text-danger text-center">{error}</p>}

        {/* Filters */}
        <div className="mb-4 text-center">

          <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
            <button className="btn btn-dark btn-sm" onClick={resetFilters}>
              All
            </button>

            {subCategories.map((cat) => (
              <button
                key={cat.id}
                className="btn btn-outline-success btn-sm"
                onClick={() => filterBySubCategory(cat.subCategoryName)}
              >
                {cat.subCategoryName}
              </button>
            ))}
          </div>

          <div className="d-flex justify-content-center">
            <select
              className="form-select w-auto"
              value={selectedType}
              onChange={(e) => filterByItemType(e.target.value)}
            >
              <option value="">Filter by Item Type</option>
              {itemTypes.map((type) => (
                <option key={type.id} value={type.ItemTypeName}>
                  {type.ItemTypeName}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Products */}
        <div className="row g-4">
          {loading ? (
            Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="col-6 col-md-4 col-lg-3">
                <Skeleton height={180} />
                <Skeleton height={20} className="mt-2" />
              </div>
            ))
          ) : filtered.length === 0 ? (
            <p className="text-center">No products found</p>
          ) : (
            filtered.map((product) => (
              <div
                key={product.ProductID}
                className="col-6 col-md-4 col-lg-3"
              >
                <div className="card product-card h-100 border-0 shadow-sm">

                  <img
                    src={`${configData.IMAGE_URL}/products/${product.Image}`}
                    alt={product.ProductName}
                    className="p-3"
                    style={{ height: "180px", objectFit: "contain" }}
                  />

                  <div className="card-body text-center">

                    <h6 className="fw-semibold">
                      {product.ProductName}
                    </h6>

                    <div className="text-success fw-bold mb-1">
                      {product.proSize}
                    </div>

                    <p className="text-muted small">
                      {product.Description?.substring(0, 60)}...
                    </p>

                    {/* ⭐ Rating */}
                    <Rating
                      value={product.avgRating || 4.2}
                      count={product.totalReviews || 0}
                    />

                    <div className="fw-bold text-success">
                      ৳ {product.ProductPrice.toLocaleString()} / {product.munit}
                    </div>
                  </div>

                  <div className="card-footer bg-white border-0 text-center">
                    <Link
                    to={`/product/${product.ProductID}/${product.CategoryID}`}
                      // to={"/productDetails"}
                      // state={{ 
                      //   productId: product.ProductID, 
                      //   categoryId: product.CategoryID 
                      // }}
                      className="btn btn-sm btn-outline-dark me-2"
                    >
                      View
                    </Link>

                    {product.UnitsInStock === 0 ? (
                      <button className="btn btn-sm btn-danger" disabled>
                        Out of Stock
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleAddCart(product)}
                      >
                        Add
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Featured */}
        <div className="mt-5">
          <h4 className="text-center text-success mb-3">
            Upcoming Products
          </h4>

          <div className="row g-3">
            {featured.map((product) => (
              <div
                key={product.ProductID}
                className="col-6 col-md-4 col-lg-3"
              >
                <div className="card border-0 shadow-sm h-100">
                  <img
                    src={`${configData.IMAGE_URL}/products/${product.Image}`}
                    alt={product.ProductName}
                    className="p-3"
                    style={{ height: "160px", objectFit: "contain" }}
                  />

                  <div className="card-body text-center">
                    <small className="text-muted d-block">
                      {product.ProductName}
                    </small>

                    {/* ⭐ Rating */}
                    <Rating value={product.rating || 4} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>

      <Footer />
    </>
  );
};

export default CatProducts;